import { useEffect, useRef } from 'react';

/** Aesop / Le Labo style cursor: small gold dot + ring that grows on interactive hover. */
export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    // Skip on coarse-pointer devices
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;

    let mouseX = -50, mouseY = -50, ringX = -50, ringY = -50;
    let raf = null;

    const onMove = (e) => {
      mouseX = e.clientX; mouseY = e.clientY;
      dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
    };
    const animate = () => {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(animate);
    };

    const isInteractive = (el) => !!el.closest('a, button, [role="button"], input, textarea, select, [data-cursor="link"]');
    const onOver = (e) => {
      if (isInteractive(e.target)) {
        dot.classList.add('is-hovering');
        ring.classList.add('is-hovering');
      }
    };
    const onOut = (e) => {
      if (isInteractive(e.target)) {
        dot.classList.remove('is-hovering');
        ring.classList.remove('is-hovering');
      }
    };
    const onDown = () => ring.classList.add('is-clicking');
    const onUp = () => ring.classList.remove('is-clicking');
    const onLeave = () => { dot.style.opacity = '0'; ring.style.opacity = '0'; };
    const onEnter = () => { dot.style.opacity = '1'; ring.style.opacity = '1'; };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('mouseleave', onLeave);
    document.addEventListener('mouseenter', onEnter);
    animate();

    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onOver);
      document.removeEventListener('mouseout', onOut);
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('mouseleave', onLeave);
      document.removeEventListener('mouseenter', onEnter);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={ringRef} className="cursor-ring" aria-hidden />
      <div ref={dotRef} className="cursor-dot" aria-hidden />
    </>
  );
}
